<template>
	<div class="brand_box">
		<div class="brand_title">
			创造&nbsp;<i class="el-icon-right"></i>
		</div>
		<dv-border-box-13>
			<div class="brandList">
				<div class="brandItem" v-for="(item,index) in brandList" :key="index">
					<img :src="item.path">
					<div>
						<div class="brandItem_title">{{item.title}}</div>
						<div class="brandItem_num">
							<countTo :startVal='0' :endVal='Number(item.num)' :duration='800'></countTo>
						件</div>
					</div>
				</div>
			</div>
		</dv-border-box-13>
		<div class="brand_chart">
			<div id="createChart1" style="width:100%;height:100%;"></div>
		</div>
		<div class="btn">商品类商标注册量前十</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				brandList:[],
			}
		},
		mounted() {},
		methods:{
			getData(data,list){
				this.brandList =[
					{
						path:require('@/assets/brand/create-1.png'),
						title:'商标申请量',
						num:data.sb_shenq,
					},{
						path:require('@/assets/brand/create-2.png'),
						title:'商标注册量',
						num:data.sb_zhuc,
					},{
						path:require('@/assets/brand/create-3.png'),
						title:'有效注册量',
						num:data.sb_youx,
					}
				]
				this.drawChart1(list)
			},
			drawChart1(list) {
				let myChart = this.$echarts.init(document.getElementById('createChart1'));
				// var total = 0
				for(var i in list){
					// total += list[i].count
					list[i].value = list[i].count
				}
				// for(var j  in list){
				// 	list[j].pec = (list[j].count / total)
				// }
				var option = {
					color: ['#FFA620','#24FEB4','#FF7875','#2DB8FB', '#9E43DE',],
					tooltip: {
						show: false,
					},
					legend: {
						show: true, // 是否显示图列
						left: '10%',
						bottom: '0',
						icon: "rect", // 修改形状
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff',
							fontSize:12,
						},
						data:list.map(item =>item.name),
					},
					series: [
						{
							name: 'Access From',
							type: 'pie',
							center: ['50%', '40%'],
							radius: ['55%', '70%'],
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center',
								fontSize: '12px'
							},
							labelLine: {
								show: false
							},
							emphasis: {
								label: {
									show: true,
									color: '#fff',
									fontSize:14,
									formatter: `{d}%\n\n{b}`
								}
							},
							data:list
						}
					],
				}
				var currentIndex = 0;
				var timer = 0;
				function animate() {
					timer = setInterval(function() {
						var dataLen = option.series[0].data.length;
						// 取消之前高亮的图形
						myChart.dispatchAction({
							type: 'downplay',
							seriesIndex: 0,
							dataIndex: currentIndex,
						});
						currentIndex = (currentIndex + 1) % dataLen;
						// 高亮当前图形
						myChart.dispatchAction({
							type: 'highlight',
							seriesIndex: 0,
							dataIndex: currentIndex,
						});
					}, 1500);
				}
				animate();
				// 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
				myChart.on("mouseover", function(e) {
					clearInterval(timer);
					// 取消之前高亮的图形
					myChart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
					});
					myChart.dispatchAction({
						type: 'highlight',
						dataIndex: e.dataIndex
					});
				});
				// 用户鼠标移出时，重新开始自动切换
				myChart.on("mouseout", function(e) {
					currentIndex = e.dataIndex;
					animate();
				});
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>
